import { httpsCallable } from 'firebase/functions';
import { doc, runTransaction, serverTimestamp } from 'firebase/firestore';
import { db, functions } from '../firebase';

const call = (name, payload) => httpsCallable(functions, name)(payload).then((result) => result.data);

export const beginVaultTransition = (payload) => call('beginVaultTransition', payload);
export const commitVaultTransition = (payload) => call('commitVaultTransition', payload);
export const abortVaultTransition = (payload) => call('abortVaultTransition', payload);

const isValidLockedTarget = ({ noteId, content, protection }) => typeof noteId === 'string' && noteId.length > 0 &&
  typeof content === 'string' && ((protection === 'vault' && /^encrypted:.+/.test(content)) ||
    (protection === 'standard' && !content.startsWith('encrypted:')));

export const createLockedVaultTransitionWriter = ({
  firestore = db, document = doc, transaction = runTransaction, timestamp = serverTimestamp,
  isOnline = () => window.navigator?.onLine === true,
} = {}) => async (payload) => {
  if (!isValidLockedTarget(payload)) throw new Error('Invalid locked Vault transition write.');
  if (!isOnline()) throw new Error('Vault transitions require an online connection.');
  const noteRef = document(firestore, 'notes', payload.noteId);
  return transaction(firestore, async (tx) => {
    if (!isOnline()) throw new Error('Vault transitions require an online connection.');
    tx.update(noteRef, { content: payload.content, protection: payload.protection, updatedAt: timestamp() });
  });
};

export const writeLockedVaultTransition = createLockedVaultTransitionWriter();
